// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"c02f8351","212":"8e9f67dc","506":"4fecd588","936":"61a6d057"}[chunkId] + ".chunk.css";
};